import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import SEO from './components/SEO';

// Main pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import GetQuote from './pages/GetQuote';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import About from './pages/About';
import News from './pages/News';
import NewsDetails from './pages/NewsDetails';
import Terms from './pages/legal/Terms';
import Privacy from './pages/legal/Privacy';
import Cookies from './pages/legal/Cookies';
import Pricing from './pages/Pricing';
import ServicePackages from './pages/ServicePackages';
import ServiceDesk from './pages/ServiceDesk';
import NotFound from './pages/NotFound';

// Services
import Services from './pages/services/Services';
import WebDevelopment from './pages/services/WebDevelopment';
import WebDesign from './pages/services/WebDesign';
import WebProgramming from './pages/services/WebProgramming';
import Consulting from './pages/services/Consulting';
import Marketing from './pages/services/Marketing';
import SEOPage from './pages/services/SEO';
import Analytics from './pages/services/Analytics';
import Maintenance from './pages/services/Maintenance';
import LiveChat from './pages/services/LiveChat';

// Solutions
import Solutions from './pages/solutions/Solutions';
import AI from './pages/solutions/AI';
import Subscription from './pages/solutions/Subscription';
import Booking from './pages/solutions/Booking';
import Ecommerce from './pages/solutions/Ecommerce';
import POS from './pages/solutions/POS';
import WordPress from './pages/solutions/WordPress';
import WordPressExpress from './pages/solutions/WordPressExpress';
import WordPressExpressOrder from './pages/solutions/WordPressExpressOrder';
import Hosting from './pages/solutions/Hosting';
import HostingOrder from './pages/solutions/HostingOrder';
import Email from './pages/solutions/Email';
import Vefumsjon from './pages/solutions/Vefumsjon';

function App() {
  return (
    <>
      <SEO 
        title="Vefsíðugerð og stafrænar lausnir"
        description="Vefsíða býður upp á sérsniðnar veflausnir, vefhönnun og vefþróun fyrir fyrirtæki. Fagleg þjónusta og framúrskarandi árangur."
        keywords="vefsíðugerð, vefhönnun, vefþróun, veflausnir, wordpress, netverslun, leitarvélabestun, vefumsjón"
      />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="hafa-samband" element={<Contact />} />
          <Route path="fa-tilbod" element={<GetQuote />} />
          <Route path="verdskra" element={<Pricing />} />
          <Route path="thjonustupakkar" element={<ServicePackages />} />
          <Route path="thjonustubord" element={<ServiceDesk />} />
          <Route path="verkefni" element={<Projects />} />
          <Route path="verkefni/:id" element={<ProjectDetails />} />
          <Route path="fyrirtaekid" element={<About />} />
          <Route path="frettir" element={<News />} />
          <Route path="frettir/:slug" element={<NewsDetails />} />
          
          {/* Legal pages */}
          <Route path="skilmalar" element={<Terms />} />
          <Route path="personuvernd" element={<Privacy />} />
          <Route path="vafrakokur" element={<Cookies />} />
          
          {/* Services routes */}
          <Route path="thjonusta" element={<Services />} />
          <Route path="thjonusta/vefsidugerd" element={<WebDevelopment />} />
          <Route path="thjonusta/vefhonnun" element={<WebDesign />} />
          <Route path="thjonusta/vefthroun" element={<WebProgramming />} />
          <Route path="thjonusta/radgjof" element={<Consulting />} />
          <Route path="thjonusta/markadssetning" element={<Marketing />} />
          <Route path="thjonusta/leitarvelabestun" element={<SEOPage />} />
          <Route path="thjonusta/greiningar" element={<Analytics />} />
          <Route path="thjonusta/vidhald" element={<Maintenance />} />

          {/* Solutions routes */}
          <Route path="lausnir" element={<Solutions />} />
          <Route path="lausnir/askriftarkerfi" element={<Subscription />} />
          <Route path="lausnir/bokunarkerfi" element={<Booking />} />
          <Route path="lausnir/netverslun" element={<Ecommerce />} />
          <Route path="lausnir/gervigreind" element={<AI />} />
          <Route path="lausnir/kassakerfi" element={<POS />} />
          <Route path="lausnir/wordpress" element={<WordPress />} />
          <Route path="lausnir/wordpress-express" element={<WordPressExpress />} />
          <Route path="lausnir/wordpress-express/panta" element={<WordPressExpressOrder />} />
          <Route path="lausnir/vefhysing" element={<Hosting />} />
          <Route path="lausnir/vefhysing/panta" element={<HostingOrder />} />
          <Route path="lausnir/tolvupostur" element={<Email />} />
          <Route path="lausnir/vefumsjon" element={<Vefumsjon />} />
          <Route path="lausnir/netspjall" element={<LiveChat />} />

          {/* 404 page */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;